import type { FaireProductEntity } from "../../entity_types/product";

export const p_equz4cwxhh: FaireProductEntity = {
  token: "p_equz4cwxhh",
  type: "product",
  name: "Celestial Patterned Button-Up Cardigan",
  brandToken: "b_q6uy7uqavt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ed0f5b8a0fc635ea7a4bf0662c130ba3e6b9116bd1929fcabc06cc4cc8679ea5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3f93f6194a2a417b6e6fe66926308e0963dd7b3a58b52e10a73201dec20b982.jpeg",
    "https://cdn.faire.com/fastly/5c2ddaf87404fcc0b16c5931e03f4d5373eb7dd18663ee5af680c90f61f3780e.jpeg",
    "https://cdn.faire.com/fastly/b0a820e9f13bf4512646da2c9cda585572eb767cfbc238eb243f5be67bbfe2e8.jpeg",
    "https://cdn.faire.com/fastly/e39a1a9efaf27ae55c8400991ae1f9492388d1b94368449d434b368250ff6a04.jpeg",
    "https://cdn.faire.com/fastly/deb7beb8841909b6bd310f5c5ac6d3125c1920258e84c31c5a16ccfe44fb0fca.jpeg",
    "https://cdn.faire.com/fastly/459f459c76ba0f1bca29662f1c67785361dc93bc894a083ff591ae861956e22f.jpeg",
    "https://cdn.faire.com/fastly/6a6c73b67010566f84490f16a396cf23afaa0cde1ea9ddf32ca5eec67d1c3925.jpeg",
  ],
  priceDollars: 28.66,
  description:
    "Stars, moons, and sun—your mystical layering piece is here.\n\nFabric: 100% polyester\n\nWeight: 0.81 lb\n",
  tags: [],
  msrpDollars: 57.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:32.932Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
